import { toast } from './toast.js';

export function showSidePanel(id, btn) {
  document.querySelectorAll('.side-tab').forEach(t => t.classList.remove('on'));
  document.querySelectorAll('.side-panel').forEach(p => p.classList.remove('on'));
  btn.classList.add('on');
  document.getElementById(`panel-${id}`).classList.add('on');
}

/**
 * Toggle the visual "on" state of a static layer item in the sidebar.
 * User-uploaded layers are handled separately in myLayersPanel.js.
 */
export function toggleLayerItem(map, el) {
  el.classList.toggle('on');
  toast(el.classList.contains('on') ? 'Layer enabled' : 'Layer disabled');
}

export function filterLayers(q) {
  document.querySelectorAll('.litem').forEach(el => {
    const name = el.querySelector('.lname')?.textContent.toLowerCase() || '';
    el.style.display = name.includes(q.toLowerCase()) ? 'flex' : 'none';
  });
}
